module.exports = __webpack_public_path__ + "assets/img/img35.c615e807.png";